$(document).ready(function(){
  var $slider = $('.cstm-verticle-nav-slider');
$('.cstm-verticle-nav-slider').slick({
  infinite: false,
  arrows: false,
  slidesToShow: 1,
dots: true,
  customPaging: function(slider, i) {
    return '<a>' + (i + 1) + '</a>';
  },
  slidesToScroll: 1
});
$('.nav-trigger').on('click', function() {
  var slideIndex = $(this).data('value') - 1; // convert to 0-based index
  $('.cstm-verticle-nav-slider').slick('slickGoTo', slideIndex);
});

$slider.on('afterChange', function(event, slick, currentSlide) {
  $('.nav-trigger').removeClass('active');
  $('.nav-trigger[data-value="' + (currentSlide + 1) + '"]').addClass('active');
});

     $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,          // ✅ show arrows
  dots: true,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 2.5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: true,
  arrows: true, 
  centerMode: false,
  focusOnSelect: true
});
	
$('.why-love-slider').slick({
  infinite: true,
slidesToShow: 3.5,
slidesToScroll: 1,
arrows: true, 
dots: false
});

})

$(document).ready(function () {

  $('.ez-discover-tabs-titles li').click(function (e) {
    e.preventDefault();

    var tabID = $(this).data('tab');

    // remove active class from all tabs
    $('.ez-discover-tabs-titles li').removeClass('ez-tab-active');

    // add active class to clicked tab
    $(this).addClass('ez-tab-active');

    // hide all tab contents
    $('.ez-discover-tab-row').hide();

    // show selected tab content
    $('.' + tabID).fadeIn();
  });

});


$(document).ready(function () {

  $('.ez-page-link-list li').click(function (e) {
    e.preventDefault();

    var sectionClass = $(this).data('section');
    var target = $('.' + sectionClass);

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 80   // adjust offset if header is sticky
      }, 600);
    }

  });

  $(".ez-pro-img-hover-click a").click(function(e){
  e.preventDefault();
  $(this)
    .closest(".ez-pro-img-hover-box")
    .toggleClass("ez-pro-img-hover-open");
});


});

$(document).ready(function () {

  $('.ez-page-sticky-left-new li').click(function (e) {
    e.preventDefault();

    var targetClass = $(this).data('id');
    var target = $('.' + targetClass);

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 20  // adjust for sticky header
      }, 400);
    }

    // active state
    $('.ez-page-sticky-left-new li').removeClass('active');
    $(this).addClass('active');

  });
 $('.faq-scroll-link').click(function (e) {
  e.preventDefault();

  var target = $(this).attr('href'); // get #faq-id

  if ($(target).length) {
    $('html, body').animate({
      scrollTop: $(target).offset().top // adjust for header
    }, 500);
  }

  // active state
  $('.faq-scroll-link').removeClass('active');
  $(this).addClass('active');
});
});

document.querySelectorAll('.section-one-cstm').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault(); // stop default anchor behavior

    const target = document.querySelector('.cstom-multi-colm .cstm-subtitle');
    
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});


document.querySelectorAll('.section-two-cstm').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault(); // stop default anchor behavior

    const target = document.querySelector('.ez-discover-tabs-sec');
    
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});

document.querySelectorAll('.section-three-cstm').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault(); // stop default anchor behavior

    const target = document.querySelector('.collapsible-content');
    
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});


document.querySelectorAll('.mega-menu').forEach((menu) => {

  const summary = menu.querySelector('summary');
  if (!summary) return;

  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  menu.addEventListener('mouseleave', () => {
    menu.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });

});

const firstTab = document.querySelector('.tab-custom-first');
if (firstTab) {
  firstTab.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector('#custom-device');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
}

const secondTab = document.querySelector('.tab-custom-second');
if (secondTab) {
  secondTab.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector('#custom-access');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
}

// document.querySelectorAll('summary').forEach(summary => {
//   summary.addEventListener('click', function(e) {
//     e.preventDefault(); // stop default

//     const details = this.parentNode;
//     const isOpen = details.hasAttribute('open');

//     document.querySelectorAll('details').forEach(d => d.removeAttribute('open'));

//     if (!isOpen) {
//       details.setAttribute('open', true);
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.collapsible-content details summary').forEach(summary => {

    summary.addEventListener('click', function () {

      const details = this.parentNode;
      const isOpen = details.hasAttribute('open');

      // close only siblings inside same section
      const parent = details.closest('.collapsible-content');

      if (parent) {
        parent.querySelectorAll('details').forEach(d => {
          if (d !== details) {
            d.removeAttribute('open');
          }
        });
      }

      // allow default toggle (DO NOT use preventDefault)
      if (!isOpen) {
        details.setAttribute('open', true);
      }

    });

  });

});

document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('sticky-header');

  if (header && header.closeSearchModal) {

    const originalFunction = header.closeSearchModal;

    header.closeSearchModal = function () {

      if (!this.searchModal) return; // prevent error

      originalFunction.apply(this, arguments);

    };

  }

});



// const videos = document.querySelectorAll(".ez-bg-video");

// const observer = new IntersectionObserver((entries) => {

//   entries.forEach(entry => {

//     const video = entry.target;

//     if(entry.isIntersecting){
//       video.play().catch(()=>{});
//     } else {
//       video.pause();
//     }

//   });

// }, { threshold: 0.3 });

// videos.forEach(video => observer.observe(video));



document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".ez-bg-video");
  const button = document.querySelector(".video-control-play");

  if (!video || !button) return;

  // Force correct attributes
  video.muted = true;
  video.loop = true;

  // Autoplay on load
  video.play().catch(() => {});

  // Initial state: playing
  button.classList.remove("is-paused");

  // Toggle using CLASS state (not video.paused)
  button.addEventListener("click", function () {
    if (button.classList.contains("is-paused")) {
      video.play();
      button.classList.remove("is-paused"); // show pause
    } else {
      video.pause();
      button.classList.add("is-paused"); // show play
    }
  });

  // Sync state if video changes unexpectedly
  video.addEventListener("pause", () => {
    button.classList.add("is-paused");
  });

  video.addEventListener("play", () => {
    button.classList.remove("is-paused");
  });
});